module.exports = __webpack_public_path__ + "static/media/gemix.playngo.aba3b9f9.jpeg";